(function ($) {
  const duration = 300;


  /**
   * スライダー
   */
  function itemlistCarousel() {
    const carousels = document.getElementsByClassName('js-itemlist-carousel');
    [...carousels].forEach(carousel => {
      const myOptions = {
        speed: 1000,
        loop: true,
        effect: 'fade',
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        centeredSlides: true,
        slidesPerView: 'auto',
      };

      if (carousel.querySelectorAll('.swiper-slide').length > 1) {
        const mainSlider = new Swiper(carousel, myOptions);
      }
    });
  }


  /*
  * アコーディオン
  */
  function toggleInit() {
    if ($('.js-toggle').length) {
      $('.js-toggle').find('.js-toggle-label').each(function () {
        if (!$(this).hasClass('is-opened')) {
          $(this).siblings('.js-toggle-content').hide();
        }
        $(this).on('click', function () {
          if ($('+.js-toggle-content', this).not(':animated').length > 0) {
            $('+.js-toggle-content', this).slideToggle(duration);
            $(this).toggleClass('is-opened');
          }
          return false;
        });
      });
    };
  }

  /*
  * スクロールアニメーション
  */
  const delta = $(window).height() / 1.6;
  function scrollEffect() {
    $('.js-effect').each(function (i) {
      const elemPosition = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > elemPosition - delta) {
        $(this).addClass('is-visible');
      } else {
        $(this).removeClass('is-visible');
      }
    });
  }


  /**
   * ready
   */
  $(function() {
    itemlistCarousel();
    toggleInit();
  });
  
  /**
   * scroll
   */
  $(window).scroll(() => {
    scrollEffect();
  });


  /**
   * load
   */
  $(window).on('load', () => {
    scrollEffect();
  });
})(window.jQuery);
